import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";

export default function LandingPage() {
  const navigate = useNavigate();
  const publicUrl = process.env.PUBLIC_URL || "";

  const courses = [
    {
      title: "General Virtual Assistance",
      description:
        "Master essential administrative skills and become a reliable virtual assistant.",
      coverImage: "/gva.jpg",
    },
    {
      title: "Real Estate VA Training",
      description:
        "Learn lead management, cold calling, CRM skills, and U.S. real estate processes.",
      coverImage: "/realestate.jpg",
    },
    {
      title: "Ecommerce VA Training",
      description:
        "Become an expert in product listing, order fulfillment, and store management.",
      coverImage: "/ecommerce.jpg",
    },
    {
      title: "Social Media & Marketing VA",
      description:
        "Create content, manage social pages, and run ads with confidence.",
      coverImage: "/marketing.jpg",
    },
    {
      title: "Technical VA Training",
      description:
        "Website management, automation, CRM setup, and advanced tools.",
      coverImage: "/technical.jpg",
    },
    {
      title: "Finance & Bookkeeping VA",
      description:
        "Learn bookkeeping, invoicing, QuickBooks, and financial support tasks.",
      coverImage: "/finance.jpg",
    },
    {
      title: "Specialized Niches",
      description:
        "Podcast VA, CEO Executive Assistant, Content VA, and more premium niches.",
      coverImage: "/specialized.jpg",
    },
    {
      title: "Niche Mastery Programs",
      description:
        "Deep-dive training for high-income VA paths.",
      coverImage: "/niche.jpg",
    },
  ];

  return (
    <div className="min-h-screen bg-[#1A1D24] text-white font-sans">
      {/* ================= HEADER ================= */}
      <header className="flex justify-between items-center px-6 py-5 border-b border-gray-800">
        <h1 className="text-2xl font-extrabold tracking-wider text-orange-400">
          VA Academy Pro
        </h1>

        <button
          onClick={() => navigate("/login")}
          className="px-4 py-2 text-sm border border-gray-600 rounded-full hover:bg-gray-700 transition"
        >
          Admin / Student Login
        </button>
      </header>

      {/* ================= HERO ================= */}
      <section className="relative h-[70vh]">
        <img
          src={publicUrl + "/va-hero.jpg"}
          alt="Virtual Assistant"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center px-4">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-bold"
          >
            Virtual Assistant Academy Pro
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-4 text-lg md:text-2xl max-w-2xl text-gray-200"
          >
            Upgrade your skills. Become a high-earning Virtual Assistant.
          </motion.p>

          <a
            href="https://m.me/867245013147706"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="mt-6 px-8 py-3 text-lg rounded-2xl bg-orange-500 hover:bg-orange-600">
              Enroll Now – 50% OFF
            </Button>
          </a>
        </div>
      </section>

      {/* ================= COURSES ================= */}
      <section className="py-16 bg-[#252831]">
        <h2 className="text-4xl font-bold text-center mb-12 text-orange-400">
          Our Training Programs
        </h2>

        {/* 🔑 CENTERED CONTAINER */}
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {courses.map((course, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <Card className="bg-gray-700 border border-gray-600 rounded-2xl overflow-hidden flex flex-col h-full">
                  <img
                    src={publicUrl + course.coverImage}
                    alt={course.title}
                    className="w-full h-40 object-cover"
                  />

                  <CardContent className="p-6 flex flex-col flex-grow">
                    <h3 className="text-xl font-semibold mb-2">
                      {course.title}
                    </h3>

                    <p className="text-gray-300 mb-6 flex-grow">
                      {course.description}
                    </p>

                    <a
                      href="https://m.me/867245013147706"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="w-full bg-blue-600 hover:bg-blue-700 rounded-xl">
                        Inquire Now
                      </Button>
                    </a>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="text-center py-4 text-xs text-gray-500 border-t border-gray-800">
        © {new Date().getFullYear()} Virtual Assistant Academy Pro
      </footer>
    </div>
  );
}
